import { useEffect, useState } from 'react'
import { List, ListItem, ListItemText } from '@mui/material'
import Button from '@mui/material/Button'
import { ContextModel } from '../../shared/model/models'
import { contextModelAPI } from '../../shared/api/ContextModelAPI'
import FsDescriptiveCharacteristicsSelect from './fs-descriptive-characteristics-select'

type FsDescriptiveCharacteristicsProps = {
  onComplete?: () => void
}

const FsDescriptiveCharacteristics = (props: FsDescriptiveCharacteristicsProps) => {
  const { onComplete } = props
  const [contextModels, setContextModels] = useState<ContextModel[]>([])

  const onDone = () => {
    contextModelAPI
      .saveIndependentCharacteristicsConstantForContextModel()
      .then(() => onComplete?.())
      .catch(() => null)
  }

  useEffect(() => {
    contextModelAPI
      .getContextModels()
      .then((response) => {
        /* const filtered = response.filter(
                (value, idx, self) =>
                    self.findIndex(
                        (val) =>
                            val.dependentCharacteristic.id ===
                            value.dependentCharacteristic.id,
                    ) === idx,
            ); */
        setContextModels(response)
      })
      .catch(() => null)
  }, [])

  return (
    <div className="fs-descriptive-characteristics">
      <List sx={{ width: '90%' }}>
        {contextModels?.map((contextModel: ContextModel) => (
          <ListItem key={contextModel.dependentCharacteristic.id}>
            <ListItemText
              sx={{ minWidth: '20%' }}
              id={`list-item-id-${contextModel.dependentCharacteristic.id}`}
              primary={`${contextModel.dependentCharacteristic.name}/${contextModel.diversityDimension.name}`}
            />
            <FsDescriptiveCharacteristicsSelect contextModel={contextModel} />
          </ListItem>
        ))}
      </List>
      <Button onClick={onDone}>Done</Button>
    </div>
  )
}

export default FsDescriptiveCharacteristics
